<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>search</mat-icon>
        <h1>{{'エントリー情報：検索条件' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="search()">
          <mat-icon>search</mat-icon>
          <span>{{'検索' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content [formGroup]="editForm">
    <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">
      <mat-form-field floatLabel="always">
        <mat-label>{{'イベント' | translate}}</mat-label>
        <mat-select placeholder="{{'イベント' | translate}}" formControlName="entrance_exit_event_id" (selectionChange)="entry_no.setValue('')">
          <mat-option [value]=""></mat-option>
          <mat-option *ngFor="let entranceExitEvent of entranceExitEvents" [value]="entranceExitEvent.id">
            {{ entranceExitEvent.names[0].name }}  ({{ entranceExitEvent.open_start_date.seconds * 1000 | date: 'yyyy/MM/dd' }} - {{ entranceExitEvent.open_end_date.seconds * 1000 | date: 'yyyy/MM/dd' }})
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field floatLabel="always">
        <mat-label>{{'エントリー番号' | translate}}</mat-label>
        <input matInput placeholder="{{'エントリー番号' | translate}}" formControlName="entry_no" (change)="entrance_exit_event_id.setValue('');">
      </mat-form-field>
    </div>
  </div>
</div>

